import { useCreateGenericEventMutation } from "~graphql/events.generated"
import { useUser } from "~contexts/user-provider"
import { useOutfitterContext } from "~contexts/outfitter-provider"

export function useCreateGenericEvent() {
    const { user, isAdmin } = useUser()
    const { outfitterId } = useOutfitterContext()

    const [createGenericEventMutation, { loading: isLoading }] =
        useCreateGenericEventMutation()

    const createGenericEvent = ({
        eventType,
        metadata,
    }: {
        eventType: string
        metadata?: Record<string, unknown>
    }) => {
        if (!user) return

        const enrichedMetadata = {
            ...metadata,
            is_admin: isAdmin,
            outfitter_id: outfitterId,
        }
        const data = {
            user_id: user.id,
            event_type: eventType,
            metadata: enrichedMetadata,
        }

        void createGenericEventMutation({ variables: { data } })
    }

    return { createGenericEvent, isLoading }
}
